"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SVG = void 0;
var _react = _interopRequireWildcard(require("react"));
var _bricksUtils = require("@titelmedia/bricks-utils");
var _styles = require("./styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const SVG = ({
  svgLandscape,
  svgPortrait,
  useContainer,
  enableRotation,
  rotateNumber,
  rotationDirection
}) => {
  const wrapperRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (!wrapperRef.current || !enableRotation) return;
    _bricksUtils.gsap.set(wrapperRef.current, {
      rotation: () => rotationDirection == 'left' ? `-${rotateNumber}` : `${rotateNumber}`
    });
    let rotationAnimation = _bricksUtils.gsap.effects.rotation(wrapperRef.current, {
      rotation: () => rotationDirection == 'left' ? `${rotateNumber}` : `-${rotateNumber}`,
      trigger: wrapperRef.current,
      start: '10% bottom',
      end: `+=${wrapperRef.current.offsetWidth + 200}`,
      scrub: 1
    });
    return () => {
      if (rotationAnimation) rotationAnimation.kill();
    };
  }, [enableRotation, rotateNumber, rotationDirection]);
  return _react.default.createElement(_styles.Container, {
    ref: wrapperRef,
    useContainer: useContainer
  }, svgPortrait && _react.default.createElement(_styles.SvgMobile, {
    src: svgPortrait
  }), svgLandscape && _react.default.createElement(_styles.SvgDesktop, {
    src: svgLandscape
  }));
};
exports.SVG = SVG;
//# sourceMappingURL=index.js.map